module.exports = __webpack_public_path__ + "static/media/eleven_horizontal_white.7d249867.jpeg";